// @ts-check
import React from 'react';

import hostingDetailsAlsowith from 'pages/servers/details/hostingDetailsAlsowith';
import useAssetDetails from 'modules/queries/asset/useDetails';
import { useParams } from 'react-router';
import ActionsLoader from './ActionsLoader';
import ActionsContent from './ActionsContent';

const Actions = () => {
	/** @type { {uniqId: string} } */
	const { uniqId } = useParams();
	const { data, isLoading, isError } = useAssetDetails(
		{
			alsowith: hostingDetailsAlsowith,
			uniq_id: uniqId,
		},
		{ enabled: Boolean(uniqId) },
	);

	if (isError) {
		return null;
	}

	if (isLoading) {
		return <ActionsLoader />;
	}

	return <ActionsContent {...data} />;
};

export default Actions;
